import styled from '@emotion/styled';

import { css } from 'config/emotionCss';

import colors from 'config/theme/colors';

export const WrapperContent = styled.div`
  margin: -12px;
  width: 370px !important;
`;

export const PopoverContent = styled.div`
  padding: 24px 16px;
  h3 {
    position: relative;
    color: ${colors['@text-color']};
    font-weight: 700 !important;
    padding-bottom: 8px;
    margin-bottom: 16px;
    text-transform: uppercase;
    &:after {
      position: absolute;
      content: '';
      left: 0;
      bottom: 0;
      width: 30px;
      height: 2px;
      border-radius: 2px;
      background-color: ${colors['@label-color']};
    }
  }
  p {
    color: ${colors['@text-color']};
    b {
      color: ${colors['@text-color']};
    }
    &.campusText b {
      color: ${colors['@primary-color']};
    }
  }
  .btn_campus {
    margin-top: 16px;
    display: flex;
    justify-content: center;
    text-align: center;
    padding: 10px;
    line-height: 20px;
    border: 1px solid ${colors['@label-color']};
    border-radius: 2px;
    color: ${colors['@text-color']};
    transition: all 300ms;
    &:hover {
      color: #ffffff;
      background: rgba(29, 37, 45, 0.2);
    }
  }
  ul {
    padding: 0;
    margin-bottom: 0;
    li {
      margin-bottom: 8px;
      a {
        font-weight: 500 !important;
      }
    }
    i,
    span.fb-icon {
      width: 24px;
      height: 24px;
      margin-right: 12px;
      background: rgba(0, 55, 99, 0.05);
      border-radius: 4px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const PopoverFooter = styled.div`
  background-color: ${colors['@body-bg']};
  text-align: center;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    line-height: 35px;
    font-weight: 500 !important;
    margin: 0;
  }
  a {
    color: ${colors['@text-color']};
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const IconHeart = css`
  color: ${colors['@red-heart']};
  margin: 0px 4px;
`;
